import { AllowedLanguage } from 'locale/util'
import { USER_SETTING_LANGUAGE_DEFAULT } from 'modules/users/consts'

export interface SettingsStore {
  language: AllowedLanguage
}
export const settingsStore: SettingsStore = {
  language: USER_SETTING_LANGUAGE_DEFAULT,
}
